import type React from "react";
import { ThreeDWrapper } from "./3d-wrapper.core";
import BoostIcon from "../../../assets/svgs/common/boost.svg";

interface RadioCardProps {
  label: string;
  description?: string;
  value: string;
  selectedValue: string;
  onChange: (value: string) => void;
  icon?: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

export const RadioCard: React.FC<RadioCardProps> = ({
  label,
  description,
  value,
  selectedValue,
  disabled,
  onChange,
  icon,
  className,
}) => {
  const isSelected = selectedValue === value;

  const handleClick = () => {
    if (!disabled) {
      onChange(value); // Pass the value prop to onChange
    }
  };

  return (
    <ThreeDWrapper
      hover={false}
      onClick={handleClick}
      className={`${disabled ? "cursor-not-allowed" : "cursor-pointer"} transition-all ${
        isSelected ? "bg-primarybuttonbg" : "bg-white"
      } ${disabled ? "opacity-50" : ""} ${className}`}
    >
      <button
        type="button"
        disabled={disabled}
        onClick={(e) => {
          e.preventDefault();
          handleClick();
        }}
        className={`flex items-center gap-4 p-2 w-full text-left ${
          disabled ? "cursor-not-allowed" : ""
        }`}
      >
        <div
          className={`flex justify-center items-center p-0  ${
            isSelected ? "border-0" : "border"
          } ${disabled ? "border-gray-300" : "border-black"} rounded-full w-5 h-5 ${
            disabled ? "bg-gray-100" : ""
          }`}
        >
          {isSelected ? (
            <BoostIcon className={`w-full h-full ${disabled ? "opacity-50" : ""}`} />
          ) : null}
        </div>
        <div className="flex flex-col flex-1 gap-1">
          <div className="flex items-center gap-2">
            {icon && (
              <span className={`text-xl ${disabled ? "opacity-50" : ""}`}>
                {icon}
              </span>
            )}
            <span
              className={`font-medium text-base ${
                disabled ? "text-gray-400" : ""
              }`}
            >
              {label}
            </span>
          </div>
          {description && (
            <p
              className={`font-figtree font-normal text-xs ${
                disabled ? "text-gray-300" : "text-secondary"
              }`}
            >
              {description}
            </p>
          )}
        </div>
      </button>
    </ThreeDWrapper>
  );
};